/**
 * Deploy tier + release for business-web observability — ONE source.
 *
 * Both the Sentry/PostHog init (`observability.ts`) and the auth-context sync
 * (`core/components/ObservabilityAuthSync.tsx`) read these, so they can never
 * disagree about which tier an event belongs to.
 *
 * The tier is resolved by `@tonnie/observability`: `VITE_ENVIRONMENT` first,
 * then the bundler's own PROD flag. `NODE_ENV` is deliberately not part of the
 * chain (W0.3 · F16 / G12) — it says `production` in every build container. An
 * unknown tier throws at boot instead of mislabelling every event.
 */

import { resolveObservabilityEnvironment } from '@tonnie/observability';
import type { ObservabilityEnvironment } from '@tonnie/observability';

export const OBSERVABILITY_ENV: ObservabilityEnvironment = resolveObservabilityEnvironment({
  VITE_ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT,
  derived: import.meta.env.PROD ? 'production' : 'development',
});

export const OBSERVABILITY_RELEASE: string = import.meta.env.VITE_RELEASE || 'dev';
